import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel, { CarouselItem } from 'tbk-components/src/components/Carousel';

import CaseStudyPromo, { ICaseStudyPromoProps } from '../CaseStudyPromo';
export interface ICaseStudyPromoCarouselProps extends IBaseElementProps {
	/**
	 * @control uniqueid
	 * @prefix case-study-promo-carousel
	 */
	id?: string;
	caseStudies?: ICaseStudyPromoProps[];
	inverted?: boolean;
}

/**
 * Calian Case Study Promo
 * @icon format-gallery
 * @block
 */
const CaseStudyPromoCarousel: React.FC<ICaseStudyPromoCarouselProps> = ({
	className,
	caseStudies = [],
	id,
	inverted = false,
}) => {
	return (
		<div className="calian-case-study-promo-carousel">
			<Carousel
				className={
					className ||
					cn('calian-full-width-gallery__carousel px-lg-5')
				}
				showBullets={false}
				id={id}
			>
				{caseStudies.map((study, i) => (
					<CarouselItem key={i}>
						<CaseStudyPromo
							className="img-fluid promo-banner"
							inverted={inverted}
							{...study}
						/>
					</CarouselItem>
				))}
			</Carousel>
		</div>
	);
};
export default CaseStudyPromoCarousel;
